import LineChartWidget from './LineChartWidget';
import BarChartWidget from './BarChartWidget';
import PieChartWidget from './PieChartWidget';
import FunnelWidget from './FunnelWidget';
import StackedAreaWidget from './StackedAreaWidget';
import MapWidget from './MapWidget';
import USAMapWidget from './USAMapWidget';
import StackedBarChartWidget from './StackedBarChartWidget';
import CardWidget from './CardWidget';

/**
 * Widget Registry - Maps widget types to their corresponding components
 * Add new widget types here as they are implemented
 */
const widgetRegistry = {
  LINE: LineChartWidget,
  BAR: BarChartWidget,
  PIE: PieChartWidget,
  FUNNEL: FunnelWidget,
  STACKED: StackedAreaWidget,
  AREA: StackedAreaWidget, // Alias for STACKED
  STACKED_BAR: StackedBarChartWidget,
  MAP: MapWidget,
  MAP_USA: USAMapWidget,
  CARD: CardWidget,
};

/**
 * Get the appropriate widget component for a given type
 * @param {string} widgetType - The type of widget (LINE, BAR, PIE, etc.)
 * @returns {Component|null} The widget component or null if not found
 */
export const getWidgetComponent = (widgetType) => {
  // Handle types with parameters like "-TOP5"
  const baseType = widgetType.split('-')[0];
  return widgetRegistry[widgetType] || widgetRegistry[baseType] || null;
};

export default widgetRegistry;
